import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 4),
    backgroundColor: '#1F2937',
    textAlign: 'left',
  },
  copyrightText: {
    color: theme.palette.common.white,
    fontSize: 14,
    padding: theme.spacing(2.5, 0),
    lineHeight: '150%',
    maxWidth: 270,
  },
  link: {
    '& a': {
      color: theme.palette.common.white,
      textDecoration: 'none',
      fontSize: 14,
      lineHeight: '22px',
      whiteSpace: 'nowrap',
    },
  },
  verticalDivider: {
    color: theme.palette.common.white,
    padding: theme.spacing(0, 1),
    fontSize: 14,
    lineHeight: '22px',
  },
}));
